import { NavLink, useLocation } from 'react-router-dom';

import { cn } from '~/utils/cn';

import { Icon } from '../../atoms/Icon/view';
import { Text } from '../../atoms/Text/view';
import type { propsIconsNames } from '../../atoms/Icon/interfaces';

const TABS: { to: string; label: string; icon: propsIconsNames }[] = [
  { to: '/app/home', label: 'Início', icon: 'icon-home' },
  { to: '/app/alerts', label: 'Alertas', icon: 'icon-notification' },
  { to: '/app/add', label: 'Novo', icon: 'icon-more' },
  { to: '/app/reports', label: 'Relatórios', icon: 'icon-extract' },
  { to: '/app/ferramentas/calculadora', label: 'Ferramentas', icon: 'icon-graphic-up' },
  { to: '/app/profile', label: 'Perfil', icon: 'icon-user' },
];

export default function TabBar() {
  const location = useLocation();
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-intense-01 border-t border-intense-03 shadow-level3 rounded-t-[16px] xl:hidden safe-area-bottom">
      <ul className="relative flex items-start justify-around mx-auto pt-smaller pb-small">
        {TABS.map((tab, index) => {
          const active = location.pathname.startsWith(tab.to);
          const isCenter = index === 2;

          if (isCenter) {
            return (
              <li key={tab.to} className="flex-1 mt-[-26px]">
                <NavLink to={tab.to} className="flex flex-col items-center pt-quark">
                  <div
                    className={cn(
                      'h-[50px] w-[50px] rounded-[16px] bg-primary-01 flex items-center justify-center shadow-level4',
                    )}
                  >
                    <Icon name={tab.icon} size={24} color="#FFFFFF" rounded={false} />
                  </div>
                  <Text
                    className={cn(
                      'mt-quark',
                      active ? 'color-primary-01 text-captionLG' : 'color-intense-06 text-captionMD',
                    )}
                  >
                    {tab.label}
                  </Text>
                </NavLink>
              </li>
            );
          }

          return (
            <li key={tab.to} className="flex-1">
              <NavLink
                to={tab.to}
                className="flex flex-col items-center justify-center h-[50px] gap-quark"
              >
                <Icon
                  name={tab.icon}
                  size={24}
                  color={active ? '#1D4733' : '#808080'}
                  rounded={false}
                />
                <Text
                  className={cn(
                    active ? 'color-primary-01 text-captionLG' : 'color-intense-06 text-captionMD',
                  )}
                >
                  {tab.label}
                </Text>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export { TABS as TAB_DEFS };
